<template>
  <div class="field-editor-form row no-gutters">
    <div class="col-12 mb-3 col-xl-6 pr-xl-3">
      <Field type="text" name="field_label" label="Label *" v-model="field.label" />
    </div>

    <div class="col-12 mb-3 col-xl-6 pl-xl-3">
      <Field
        type="select"
        name="field_type"
        label="Field Type *"
        v-model="field.type"
        :options="fieldTypes"
        :hideSelectEmptyOption="true"
      />
    </div>

    <div v-if="hasOptions" class="col-12 mb-3">
      <div class="field-options element">
        <label>{{ fieldTypeLabel }} Field Options</label>
        <template v-for="(v, i) in field.value">
          <div :key="i" class="field-option row no-gutters">
            <div class="col-12 mb-3 col-xl-6 pr-xl-3">
              <Field type="text" name="field_options[]" v-model="field.value[i]" />
            </div>
            <div class="col-12 mb-3 col-xl-6 pl-xl-3 pt-1">
              <div
                class="d-inline-block mr-2 option-btn option-add"
                @click="addOption()"
                title="Add Another Option"
              >
                <icon icon="plus" class="icon" />
              </div>
              <div
                v-if="i > 0"
                class="d-inline-block option-btn option-remove"
                @click="removeOption(i)"
                title="Remove This Option"
              >
                <icon icon="plus" class="icon" />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="isForm && canAutoPopulate" class="col-12 mb-3 col-xl-6 pr-xl-3">
      <Field
        type="select"
        name="field_autofill"
        label="Auto-populate this field with..."
        v-model="field.autofill"
        :options="autoPopulateFields"
      />
    </div>

    <div v-if="isSurvey && isHtmlField" class="col-12 mb-3"> 
      <HtmlField v-model="field.value" name="value" value="" />
    </div>

    <div v-if="isSurvey && fieldGroups.length > 0" class="col-12 mb-3 col-xl-6 pr-xl-3">
      <Field
        type="select"
        name="field_group_id"
        label="Field Group"
        v-model="field.group_id"
        :options="fieldGroups"
      />
    </div>

    <div v-if="canBeRequired" class="col-12 mb-3">
      <Field
        type="checkbox"
        name="field_is_required"
        id="cb_field_is_required"
        label="This field is required"
        v-model="field.is_required"
        :checkbox-value="1"
      />
    </div>

    <div class="col-12 mb-3">
      <Field
        type="checkbox"
        name="field_is_conditional"
        id="cb_field_is_conditional"
        label="Show or hide this field using conditional logic"
        v-model="field.is_conditional"
        :checkbox-value="1"
      />
    </div>

    <div v-if="!!field.is_conditional" class="col-12 mb-3">
        <div v-if="conditionalTargets.length === 0" class="alert alert-info" >
          <span>There are no other fields available for creating conditions for this field</span>
        </div>
        <div v-else class="row field-conditions">
          <div class="col-12 mb-3">
            <Field
              type="select"
              name="field_conditional_visibility"
              v-model="field.conditional_visibility"
              :options="conditional.visibility"
              :hideSelectEmptyOption="true"
              elementClass="d-inline-block"
              inputClass="w-auto"
            />
            <p class="d-inline-block mx-2 mb-0">this field if</p>
            <Field
              type="select"
              name="field_conditional_scope"
              v-model="field.conditional_scope"
              :options="conditional.scope"
              :hideSelectEmptyOption="true"
              elementClass="d-inline-block"
              inputClass="w-auto"
            />
            <p class="d-inline-block mx-2 mb-0">of the following conditions are met</p>
          </div>
          <div
              v-for="(condition, i) in field.conditions"
              class="field-option col-12 mb-3"
          >
            <Field
              type="select"
              :name="`field_condition_target_${i}`"
              v-model="condition.target_id"
              :options="conditionalTargets"
              :hideSelectEmptyOption="true"
              elementClass="d-inline-block mr-2"
              inputClass="w-auto"
            />
            <Field
              type="select"
              :name="`field_condition_operand_${i}`"
              v-model="condition.operand"
              :options="conditional.operands"
              :hideSelectEmptyOption="true"
              elementClass="d-inline-block mr-2"
              inputClass="w-auto"
            />
            <Field
              type="select"
              :name="`field_condition_value_${i}`"
              v-model="condition.value"
              :options="conditionalValues(condition.target_id)"
              :hideSelectEmptyOption="true"
              elementClass="d-inline-block mr-3"
              inputClass="w-auto"
            />
            <div
              class="d-inline-block mr-2 option-btn option-add"
              @click="addCondition()"
              title="Add Another Condition"
            >
              <icon icon="plus" class="icon" />
            </div>
            <div
              v-if="i > 0"
              class="d-inline-block option-btn option-remove"
              @click="removeCondition(i)"
              title="Remove This Condition"
            >
              <icon icon="plus" class="icon" />
            </div>
          </div>
        </div>
    </div>

    <div class="col-12">
      <a class="btn btn-info mr-2" href="#" @click.prevent="submit()">Attach Field</a>
      <a class="btn btn-danger" href="#" @click.prevent="reset()">Reset Form</a>
    </div>
  </div>
</template>

<script>
import FieldEditorMixin from "mixins/Forms/FieldEditor";
import HtmlField from 'components/forms/HtmlField'
export default {
    components: {HtmlField},
    mixins: [FieldEditorMixin]
};
</script>